import { useState, useEffect, useRef } from 'react'

interface UseTypingEffectProps {
  phrases: string[]
  typingSpeed?: number
  deletingSpeed?: number
  pauseDuration?: number
}

const useTypingEffect = ({
  phrases,
  typingSpeed = 100,
  deletingSpeed = 50,
  pauseDuration = 2000
}: UseTypingEffectProps) => {
  const [currentText, setCurrentText] = useState('')
  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0)
  const [isDeleting, setIsDeleting] = useState(false)
  const timeoutRef = useRef<NodeJS.Timeout>()

  useEffect(() => {
    if (phrases.length === 0) return

    const currentPhrase = phrases[currentPhraseIndex]

    const timeout = setTimeout(
      () => {
        if (!isDeleting) {
          // Digitando
          if (currentText.length < currentPhrase.length) {
            setCurrentText(currentPhrase.slice(0, currentText.length + 1))
          } else {
            // Pausa antes de começar a deletar
            setTimeout(() => setIsDeleting(true), pauseDuration)
          }
        } else {
          // Deletando
          if (currentText.length > 0) {
            setCurrentText(currentText.slice(0, -1))
          } else {
            // Vai para a próxima frase
            setIsDeleting(false)
            setCurrentPhraseIndex((prev) => (prev + 1) % phrases.length)
          }
        }
      },
      isDeleting ? deletingSpeed : typingSpeed
    )

    timeoutRef.current = timeout

    return () => clearTimeout(timeout)
  }, [
    currentText,
    currentPhraseIndex,
    isDeleting,
    phrases,
    typingSpeed,
    deletingSpeed,
    pauseDuration
  ])

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [])

  return currentText
}

export default useTypingEffect
